<template>
  <div style="display:flex;">
    <div>
      <el-tag
        class="icon-span"
        v-for="(tag,index) in taskTags"
        :key="index"
        type="info"
        :style="getColor(tag.COLOR)"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
      >
        <span>{{tag.TAGNAME}}</span>
        <!-- <span>
          <i :style="getColor(tag.COLOR)" class="el-icon-price-tag"></i>
        </span>-->
      </el-tag>
      <el-button
        v-show="showAddButton"
        size="small"
        class="button-new-tag"
        @click="showTagSelect"
      >+ 添加标签</el-button>
    </div>
    <TagSelect ref="tagSelect" :tagIds="tagIds" @getValue="getValue"></TagSelect>
  </div>
</template>

//任务标签

<script>
import TagSelect from "./TagSelect.vue";
import { AddTaskTag, DelTaskTag } from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
const person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.companyId,
  COMPANYNAME: cookieUser.companyName
};
export default {
  components: {
    TagSelect: () => import("./TagSelect.vue")
  },
  props: {
    taskId: {
      type: String,
      default: ""
    },
    showAddButton: {
      type: Boolean,
      default: true
    },
    isEmitSave: {
      //创建任务时，是整体提交
      type: Boolean,
      default: false
    },
    tagSource: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      taskTags: [],
      tagIds: []
    };
  },
  watch: {
    tagSource(newValue) {
      if (newValue) {
        this.taskTags = newValue;
      }
    },
    taskTags(newValue) {
      if (newValue) {
        this.tagIds = newValue.map(o => o.TAGID);
      }
    }
  },
  methods: {
    getColor(color) {
      return `background:${color};font-size:16px`;
    },
    getValue(value) {
      if (value.IsSelect) {
        let taskTag = {
          TASKID: this.taskId,
          TAGID: value.ID,
          COLOR: value.COLOR,
          TAGNAME: value.TAGNAME,
          CREATEUSERID: value.CREATEUSERID,
          CREATEUSERNAME: value.CREATEUSERNAME,
          CREATEDEPTID: value.CREATEDEPTID,
          CREATEDEPTNAME: value.CREATEDEPTNAME,
          CREATECOMPANYID: value.CREATECOMPANYID,
          CREATECOMPANYNAME: value.CREATECOMPANYNAME
        };
        if (this.taskTags.some(o => o.TAGID == taskTag.TAGID) == false) {
          if (this.isEmitSave == false) {
            AddTaskTag(taskTag, person).then(result => {
              if (result.ResultCode > 0) {
                this.taskTags.push(taskTag);
              }
            });
          } else {
            this.taskTags.push(taskTag);
            this.$emit("update:tagSource", this.taskTags);
          }
        }
      } else {
        let tag = this.taskTags.find(o => o.TAGID == value.ID);
        if (tag) this.handleClose(tag);
      }
    },
    handleClose(tag) {
      if (this.isEmitSave == false) {
        DelTaskTag(tag.ID, person).then(result => {
          if (result.ResultCode > 0) {
            this.taskTags.splice(this.taskTags.indexOf(tag), 1);
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      } else {
        this.taskTags.splice(this.taskTags.indexOf(tag), 1);
        this.$emit("update:tagSource", this.taskTags);
      }
    },

    showTagSelect() {
      this.$refs.tagSelect.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
.icon-span .el-tag__close {
  color: #fff !important;
}
</style><style lang="scss" scoped>
.icon-span {
  margin-right: 10px;
}

.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.icon-span {
  border: 0 !important;
  margin-right: 5px;
  color: #fff !important;
  font-weight: normal !important;
}
</style>
